import React from "react";

// --- arrow icons ---
import arrowWhite from "../../images/icon/rotate-arrow-white02.svg";
import arrowBlack from "../../images/icon/rotate-arrow-black03.svg";
import { Link } from "react-router-dom";

// ---- contact items data ----
const contactData = [
  {
    location: "San Francisco, USA",
    phone: "+(1) 561 555 7689",
    email: "support@smmpanel-cheap.com",
    img: "https://images.unsplash.com/photo-1521747116042-5a810fda9664?auto=format&fit=crop&w=800&q=80",
  },
  {
    location: "London, United Kingdom",
    phone: "+1 (416) 123-4567",
    email: "uk@smmpanel-cheap.com",
    img: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=800&q=80",
  },
  {
    location: "Toronto, Canada",
    phone: "+1 (416) 123-4567",
    email: "ca@smmpanel-cheap.com",
    img: "https://images.unsplash.com/photo-1517935706615-2717063c2225?auto=format&fit=crop&w=800&q=80",
  },
];

const ContactInfoSection: React.FC = () => {
  return (
    <section className="contact pb-150">
      <div className="container">
        <div className="row mt-none-30">
          {contactData.map((item, index) => (
            <div className="col-lg-4 col-md-6 mt-30" key={index}>
              <div className="xb-contact-items img-hove-effect xb-border">
                <div className="xb-item--inner">

                  {/* Multiple hover images */}
                  <div className="xb-img">
                    <Link to="/contact">
                      <img
                        src={item.img}
                        alt="location"
                        style={{ width: "100%", height: 260, objectFit: "cover" }}
                      />
                    </Link>
                    <Link to="/contact">
                      <img
                        src={item.img}
                        alt="location"
                        style={{ width: "100%", height: 260, objectFit: "cover" }}
                      />
                    </Link>
                    <Link to="/contact">
                      <img
                        src={item.img}
                        alt="location"
                        style={{ width: "100%", height: 260, objectFit: "cover" }}
                      />
                    </Link>
                    <Link to="/contact">
                      <img
                        src={item.img}
                        alt="location"
                        style={{ width: "100%", height: 260, objectFit: "cover" }}
                      />
                    </Link>
                  </div>

                  {/* Content */}
                  <div className="xb-item--holder">
                    <p className="xb-item--location">{item.location}</p>
                    <span className="xb-item--contact_info" style={{ display: "block" }}>{item.phone}</span>
                    <span className="xb-item--contact_info" style={{ display: "block" }}>{item.email}</span>

                    <Link to="/contact" className="thm-btn form-btn mt-45">
                      VIEW LOCATION
                      <span className="xb-icon">
                        <img src={arrowWhite} alt="icon" />
                        <img src={arrowBlack} alt="icon" />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
